(function () {
  if (window.__pwbTips) return;
  window.__pwbTips = true;
  var tip = null, owner = null;
  function ensure() {
    if (tip) return tip;
    tip = document.createElement('div');
    tip.className = 'pwb-tooltip';
    tip.id = 'pwb-tooltip';
    tip.setAttribute('role', 'tooltip');
    tip.hidden = true;
    document.body.appendChild(tip);
    return tip;
  }
  function hide() {
    if (tip) tip.hidden = true;
    if (owner) owner.removeAttribute('aria-describedby');
    owner = null;
  }
  function show(el) {
    var t = el.getAttribute('data-tip');
    if (!t) return;
    ensure();
    if (owner && owner !== el) owner.removeAttribute('aria-describedby');
    tip.textContent = t;
    tip.hidden = false;
    tip.style.left = '0px';
    tip.style.top = '0px';
    var r = el.getBoundingClientRect();
    var w = tip.offsetWidth, h = tip.offsetHeight;
    var x = r.left + r.width / 2 - w / 2;
    x = Math.max(8, Math.min(x, document.documentElement.clientWidth - w - 8));
    var y = r.top - h - 8;
    if (y < 8) y = r.bottom + 8;
    tip.style.left = x + 'px';
    tip.style.top = y + 'px';
    owner = el;
    el.setAttribute('aria-describedby', 'pwb-tooltip');
  }
  function find(e) { return e.target && e.target.closest ? e.target.closest('[data-tip]') : null; }
  document.addEventListener('click', function (e) {
    var el = find(e);
    if (!el) { hide(); return; }
    e.preventDefault();
    e.stopPropagation();
    if (owner === el && tip && !tip.hidden) hide(); else show(el);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { hide(); return; }
    if (e.key === 'Enter' || e.key === ' ') {
      var el = e.target && e.target.closest ? e.target.closest('[data-tip]') : null;
      if (el) { e.preventDefault(); if (owner === el && tip && !tip.hidden) hide(); else show(el); }
    }
  }, true);
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) { var el = find(e); if (el) show(el); });
    document.addEventListener('mouseout', function (e) { if (find(e)) hide(); });
  }
  window.addEventListener('scroll', hide, { passive: true });
  window.addEventListener('resize', hide);
})();
